export default "__VITE_ASSET__CbCHwCc3__"